import classNames from 'classnames'
import { type PropsWithChildren, useRef, type ReactNode } from 'react'
import { Box, Icon, type ITooltipProps, Tooltip } from 'shared/ui'

import styles from './styles.module.scss'

export interface IChatbotTooltipProps {
  tooltipProps?: ITooltipProps
  className?: string
  fontSize?: number
}

export interface IChatbotTextTooltipProps {
  tooltip: ReactNode
  className?: string
  fontSize?: number
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

export const ChatbotTooltip = ({ className, tooltipProps, fontSize }: IChatbotTooltipProps) => {
  const ref = useRef<HTMLDivElement | null>(null)

  return (
    <Tooltip
      className={className}
      PopperProps={{ anchorEl: () => ref.current as HTMLElement }}
      {...tooltipProps}
    >
      <span className={styles.chatbotTooltipLabel}>
        <Icon ref={ref} icon='question' fontSize={fontSize} />
      </span>
    </Tooltip>
  )
}

export const ChatbotTextTooltip = ({
  className,
  tooltip,
  children,
  placement = 'top',
}: PropsWithChildren<IChatbotTextTooltipProps>) => {
  const ref = useRef<HTMLDivElement | null>(null)

  return (
    <Tooltip
      className={classNames(styles.chatbotTooltip, className)}
      sx={{ whiteSpace: 'pre-wrap' }}
      label={tooltip}
      placement={placement}
      PopperProps={{
        anchorEl: () => ref.current as HTMLElement,
      }}
      breakWord
    >
      <span className={styles.chatbotTooltipLabel}>
        {children}{' '}
        <Box
          height={16}
          width={16}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Icon
            ref={ref}
            icon={'question'}
            color={'var(--content-neutral-primary)'}
            fontSize={13}
          />
        </Box>
      </span>
    </Tooltip>
  )
}
